import { AccountSource, AccountSourceType } from 'owa-account-source-list-store';

export function isEnterprise(account: AccountSource) {
    return account.sourceType === AccountSourceType.Office365;
}
